import { ref } from 'vue';

/** Nome e gatilho efetivos (painel / APP_NAME). Fallback até o config público chegar. */
export const assistantName = ref('Linda');
export const wakeWord = ref('Linda');

let inflight: Promise<void> | null = null;

export async function loadAssistantIdentity(): Promise<void> {
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const res = await fetch('/api/config/public');
      if (!res.ok) return;
      const data = (await res.json()) as {
        config?: { app?: { name?: string; wakeWord?: string } };
      };
      const name = data.config?.app?.name?.trim();
      const wake = data.config?.app?.wakeWord?.trim();
      if (name) assistantName.value = name;
      if (wake) wakeWord.value = wake;
    } catch {
      /* painel segue com o fallback */
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function setAssistantIdentity(identity: { name?: string; wakeWord?: string }) {
  const name = identity.name?.trim();
  const wake = identity.wakeWord?.trim();
  if (name) assistantName.value = name;
  if (wake) wakeWord.value = wake;
}
